"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendBoxValue;

var _setSendBox = require("../actions/setSendBox");

var DEFAULT_STATE = '';

function sendBoxValue() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setSendBox.SET_SEND_BOX:
      state = payload.text;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX1NUQVRFIiwic2VuZEJveFZhbHVlIiwic3RhdGUiLCJwYXlsb2FkIiwidHlwZSIsIlNFVF9TRU5EX0JPWCIsInRleHQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVkdWNlcnMvc2VuZEJveFZhbHVlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNFVF9TRU5EX0JPWCB9IGZyb20gJy4uL2FjdGlvbnMvc2V0U2VuZEJveCc7XG5cbmNvbnN0IERFRkFVTFRfU1RBVEUgPSAnJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZEJveFZhbHVlKHN0YXRlID0gREVGQVVMVF9TVEFURSwgeyBwYXlsb2FkLCB0eXBlIH0pIHtcbiAgc3dpdGNoICh0eXBlKSB7XG4gICAgY2FzZSBTRVRfU0VORF9CT1g6XG4gICAgICBzdGF0ZSA9IHBheWxvYWQudGV4dDtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsYUFBYSxHQUFHLEVBQXRCOztBQUVlLFNBQVNDLFlBQVQsR0FBZ0U7RUFBQSxJQUExQ0MsS0FBMEMsdUVBQWxDRixhQUFrQzs7RUFBQTtFQUFBLElBQWpCRyxPQUFpQixRQUFqQkEsT0FBaUI7RUFBQSxJQUFSQyxJQUFRLFFBQVJBLElBQVE7O0VBQzdFLFFBQVFBLElBQVI7SUFDRSxLQUFLQyx3QkFBTDtNQUNFSCxLQUFLLEdBQUdDLE9BQU8sQ0FBQ0csSUFBaEI7TUFDQTs7SUFFRjtNQUNFO0VBTko7O0VBU0EsT0FBT0osS0FBUDtBQUNEIn0=